import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { MicrosoftAccessTableDataset } from 'app/model/dataset/microsoft-access-table.dataset';
import { tabularTypeDatasetAdapts, TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MicrosoftAccessTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class MicrosoftAccessTableDatasetAdapter extends TabularTypeDatasetAdapter<MicrosoftAccessTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: MicrosoftAccessTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(MicrosoftAccessTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: MicrosoftAccessTableDataset): Promise<MicrosoftAccessTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, MicrosoftAccessTableDataset.MODEL);
    }
}
